export default "__VITE_ASSET__Cj95mArw__"